import { Skeleton } from '@/components/ui/Skeleton';
import { cn } from '@/lib/utils';

export interface WorkspaceSkeletonProps {
  className?: string;
}

/**
 * Skeleton de 3 colunas espelhando o grid do WorkspaceCasoPage:
 *   stepper (18rem) | área central (flex) | painéis (22rem).
 */
export function WorkspaceSkeleton({ className }: WorkspaceSkeletonProps) {
  return (
    <div
      data-testid="workspace-skeleton"
      className={cn('grid h-full gap-4 p-4 xl:grid-cols-[18rem_minmax(0,1fr)_22rem]', className)}
    >
      {/* Coluna esquerda: stepper / pattern cards */}
      <div className="flex flex-col gap-3" data-testid="workspace-skeleton-left">
        <Skeleton className="h-6 w-1/2" />
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-20 w-full" />
        ))}
      </div>
      {/* Coluna central: imagem + decomposição */}
      <div className="flex flex-col gap-3" data-testid="workspace-skeleton-center">
        <Skeleton className="h-72 w-full" />
        <Skeleton className="h-40 w-full" />
        <Skeleton className="h-24 w-full" />
      </div>
      {/* Coluna direita: tabs Critérios / Agente */}
      <div className="flex flex-col gap-3" data-testid="workspace-skeleton-right">
        <Skeleton className="h-9 w-full" />
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    </div>
  );
}
